export default {
    classes: {
        BUBBLE_SELECT: 'bubble__focused',
        PENCIL_EDIT: 'bubble__pencil-edit'
    }
};
